import React from "react";
import { withStyles, withTheme, Grid } from "@material-ui/core";
import { compose } from "recompose";
import { FormatMinutesIntoTimeString } from "../NextStopComplianceUtills";

const styles = (theme) => ({
  kpiHeader: {
    fontWeight: "bold",
    fontSize: "18px",
    lineHeight: "21px",
    color: theme.iconColor,
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
  },
  kpiText: {
    fontWeight: "bold",
    fontSize: theme.headerTextFontSize,
    lineHeight: "16px",
    color: theme.iconColor,
    paddingBottom: "5px",
  },
  kpi: {
    fontSize: theme.headerTextFontSize,
    lineHeight: "16px",
    color: theme.iconColor,
  },
  kpiBox: {
    display: "block",
    alignItems: "center",
    textAlign: "center",
    padding: "15px 0px",
  },
  kpiRedText: {
    fontWeight: "bold",
    fontSize: theme.headerTextFontSize,
    lineHeight: "16px",
    color: theme.deviationStopPopupColor,
    paddingBottom: "5px",
  },
});
const RouteKPIValue = ({ classes, fieldName, fieldValue }) => {
  return (
    <Grid item xs={3} className={classes.kpiBox}>
      <div className={classes.kpiText}>{fieldValue}</div>
      <div className={classes.kpi}>{fieldName}</div>
    </Grid>
  );
};
const RouteKPI = ({ classes, routeData }) => {
  return (
    <React.Fragment>
      <Grid container>
        <Grid container>
          <Grid item xs={2} className={classes.kpiHeader}>
            KPI
          </Grid>
          <Grid container item xs={10}>
            <RouteKPIValue
              classes={classes}
              fieldName="Route Compliance"
              fieldValue={`${routeData.compliancePercentage}%`}
            ></RouteKPIValue>
            <RouteKPIValue
              classes={classes}
              fieldName="Extra Miles Added"
              fieldValue={routeData.extraMiles}
            ></RouteKPIValue>
            <RouteKPIValue
              classes={classes}
              fieldName="Extra Time Added"
              fieldValue={FormatMinutesIntoTimeString(routeData.extraTime)}
            ></RouteKPIValue>
            <RouteKPIValue
              classes={classes}
              fieldName="Stops"
              fieldValue={routeData.totalStops}
            ></RouteKPIValue>

            <Grid item xs={3} className={classes.kpiBox}>
              <div
                className={
                  routeData.missedApts > 0
                    ? classes.kpiRedText
                    : classes.kpiText
                }
              >
                {routeData.missedApts}
              </div>
              <div className={classes.kpi}>Missed Appt.</div>
            </Grid>

            <RouteKPIValue
              classes={classes}
              fieldName="Total Miles"
              fieldValue={`${routeData.totalMiles} mi`}
            ></RouteKPIValue>
            <RouteKPIValue
              classes={classes}
              fieldName="Total Time"
              fieldValue={FormatMinutesIntoTimeString(routeData.totalTime)}
            ></RouteKPIValue>
            <RouteKPIValue
              classes={classes}
              fieldName="Bills Per Stop"
              fieldValue={`${routeData.completedBillsPerStop} / ${routeData.totalBillsPerStop}`}
            ></RouteKPIValue>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
export default compose(withStyles(styles), withTheme())(RouteKPI);
